import { File, FileArchive, FileImage, FileSpreadsheet, FileText, type LucideIcon } from "lucide-react";
import type { FunctionComponent } from "react";
import { getFileTypeVisual, type FileTypeIconName } from "@noa/ui";

interface FileIconProps {
  fileType?: string | null;
}

const ICONS: Record<FileTypeIconName, LucideIcon> = {
  FileText,
  FileSpreadsheet,
  FileImage,
  FileArchive,
  File,
};

export const FileIcon: FunctionComponent<FileIconProps> = ({ fileType }) => {
  const { icon, colorClassName } = getFileTypeVisual(fileType);
  const Icon = ICONS[icon];

  return <Icon size={16} className={colorClassName} />;
};
